import type { AnalysisStatus } from "../../../../shared/analysis-types";

interface StatusPillProps {
  status: AnalysisStatus;
  currentSectionName: string | null;
}

export function StatusPill({ status, currentSectionName }: StatusPillProps) {
  if (status === "complete" || status === "error") return null;

  const label =
    status === "analyzing" && currentSectionName
      ? `Working on ${currentSectionName}`
      : "Starting analysis...";

  return (
    <span className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium bg-primary-soft text-primary">
      <span className="relative flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-primary" />
      </span>
      {label}
    </span>
  );
}
